module.exports = __webpack_public_path__ + "static/media/about_inner_value.de3576b7.png";